<template>
  <div>
    <!-- 作品上传 -->
    <el-dialog :close-on-click-modal="false" v-model="showFileUpload" append-to-body modal-class="glass-dialog" width="min(860px, 92vw)" :before-close="changeDialog">
      <div v-loading="isLoading" class="p-5">
        <el-form label-position="left" :model="projectInfo" ref="ruleProjectInfo" :rules="rules" label-width="80px" :inline="false" size="normal">
          <el-form-item label="作品名称" prop="workName">
            <el-input v-model="projectInfo.workName"></el-input>
          </el-form-item>
          <el-form-item label="作者介绍" prop="workAuthor">
            <el-input v-model="projectInfo.workAuthor"></el-input>
          </el-form-item>
          <el-form-item label="作品类型" prop="">
            <!-- <el-input v-model="projectInfo.workType"></el-input> -->
            <el-select v-model="projectInfo.workType" placeholder="请选择赛道" filterable>
              <el-option v-for="item in trackOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="作品介绍" prop="workIntroduce">
            <el-input class="flex w-full" v-model="projectInfo.workIntroduce" :autosize="{ minRows: 3, maxRows: 5 }" maxlength="200" placeholder="请输入作品介绍" show-word-limit type="textarea" />
          </el-form-item>

          <el-form-item label="作品备注">
            <el-input v-model="projectInfo.workNote"></el-input>
          </el-form-item>

          <el-form-item label="作品上传" prop="workVideo">
            <!-- 作品上传： 先上传视频->携带返回回来的 id 之后再进行上传 -->
            <el-upload
              ref="uploadRef"
              class="upload-demo"
              method="post"
              drag
              :limit="1"
              :data="{ platform: loginInfo.platform, action: 'WORK', id: -1 }"
              :action="BASEURL + RequestAPI.VIDEO_UPLOAD"
              :auto-upload="false"
              :headers="headers"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :on-progress="uploadingResponser"
              :before-upload="beforeAvatarUpload"
            >
              <template #trigger>
                <el-button :disabled="fileUpDisabled" type="primary">选择文件</el-button>
              </template>

              <!-- <el-button :disabled="filesListLength === 0" class="ml-3" type="success"
                                @click="">
                                上传
                            </el-button> -->

              <template #tip>
                <div class="text-xs el-upload__tip">
                  <span class="text-gray-400"> 支持上传大小不超过 <span class="text-red-400">200 MB</span> ，格式为<span class="text-red-400">mp4</span>的介绍视频。 </span>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <div class="flex flex-row gap-2 items-center w-full text-sm">
              <el-checkbox v-model="hasAgreed" label="" size="large" />
              <span class="text-slate-700">同意</span>
              <el-button link type="primary" @click="showUploadNotice = true">上传须知</el-button>
            </div>
          </el-form-item>
          <div class="demo-progress" v-if="uploadProgress > 0">
            <el-progress :text-inside="true" :stroke-width="16" :percentage="Math.round(uploadProgress)" />
          </div>
          <div class="flex flex-row justify-between w-full">
            <el-button type="primary" @click="handleConfirm" :disabled="!fileUpDisabled || !hasAgreed">确认上传</el-button>
            <el-button @click="handleClose">取消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog v-model="showUploadNotice" append-to-body modal-class="glass-dialog" width="min(720px, 92vw)" title="上传须知">
      <div class="upload-notice-body">
        <p>本人确认所上传的作品为本人及其所指导学生在合法合规前提下完成的原创作品，且对该作品依法享有相应的著作权或已取得合法授权。</p>
        <p>
          本人同意，自作品上传至此平台之日起，授权智“惠”教室项目及其相关主办、执行单位，在不改变作品原意、不用于商业牟利的前提下，为项目展示、成果传播与公益宣传之目的，无偿使用该作品及其相关内容（包括但不限于文字、图片、音视频、作品截图等）。
        </p>
        <p>授权使用形式包括但不限于：平台展示、项目汇报、成果集、宣传物料、官方网站及新媒体平台传播、线下展示活动等。本人知悉并同意，平台在使用作品时可标注作者/指导教师及所属学校信息。</p>
        <p>除上述授权用途外，智“惠”教室平台不会将作品用于与项目无关的其他用途。</p>
        <p>本人已充分理解并同意上述授权内容，确认勾选即视为本人真实、自愿的授权行为。</p>
      </div>
      <template #footer>
        <el-button type="primary" @click="showUploadNotice = false">我已知晓</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<style scoped>
.demo-progress .el-progress--line {
  margin-bottom: 15px;
  max-width: 600px;
  margin-left: 80px;
}

.upload-notice-body {
  max-height: 60vh;
  overflow: auto;
  font-size: 14px;
  line-height: 1.75;
  color: rgb(30 41 59);
}

.upload-notice-body p + p {
  margin-top: 12px;
}
</style>
<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue'
import type { FormInstance, FormRules, UploadFile, UploadInstance } from 'element-plus'
import { ElMessage, ElLoading } from 'element-plus'
import { signKey, tokenName } from '~/stores/tokenName'
import { useLoginInfo } from '~/stores/user/loginInfo'
import { useSign } from '~/stores/sign'

useHead({
  script: [
    {
      src: 'https://cdn-go.cn/cdn/vod-js-sdk-v6/latest/vod-js-sdk-v6.js',
      async: true,
      defer: true,
      type: 'text/javascript',
    },
  ],
})

const loginInfo = useLoginInfo()

const showUploadNotice = ref(false)
const hasAgreed = ref(true)

const headers = ref({
  authorization: '',
})
const fileUpDisabled = ref(false)

const props = defineProps({
  showFileUpload: Boolean,
})

const emit = defineEmits(['update:showFileUpload'])

const handleClose = () => {
  mediaFile.value = undefined
  emit('update:showFileUpload', false)
}

const mediaFile = ref<UploadFile | undefined>()
const uploadProgress = ref<number>(0)

const handleConfirm = () => {
  if (!beforeAvatarUpload()) {
    return
  }
  const tcVod = new TcVod.default({
    getSignature: getSignature,
  })
  const uploader = tcVod.upload({
    mediaFile: mediaFile.value.raw,
  })
  // 这里添加确认按钮的逻辑
  if (filesListLength.value > 0 && mediaFile.value.raw.type === 'video/mp4') {
    // workUpload();
    uploader.on('media_progress', function (info) {
      uploadProgress.value = info.percent * 100
    })

    uploader.on('media_upload', function (info) {
      console.log('上传完成', info)
    })

    uploader.done().then(function (doneResult) {
      console.log(doneResult)
      const { fileId } = doneResult
      uploadProgress.value = 0
      successResponser(fileId)
    })
    // emit('update:showFileUpload', false);
  }
}

// 将本地的响应式引用与 prop 同步
const showFileUpload = ref(props.showFileUpload)

const changeDialog = () => {
  emit('update:showFileUpload', false)
}

watch(
  () => props.showFileUpload,
  (newVal) => {
    showFileUpload.value = newVal
    console.log('获取到的新值为', showFileUpload.value)
  },
)

interface ProjectInformation {
  workName: string //作品名称
  workAuthor: string //作者
  workType: number //作品赛道
  workIntroduce: string //作品介绍
  workNote?: string //作品备注（可选）
  workVideo: string //视频 FileID
}

//作品上传的信息
const projectInfo = ref<ProjectInformation>({
  workName: '',
  workAuthor: '',
  workType: 3,
  workIntroduce: '',
  workNote: '',
  workVideo: '',
})

//赛道选择
const trackValue = ref(3)

//赛道选择器
const trackOptions = [
  {
    value: 0,
    label: '编程挑战',
  },
  {
    value: 1,
    label: '音乐创作',
  },
  {
    value: 2,
    label: '动画视频',
  },
  {
    value: 3,
    label: '创意挑战',
  },
]
//文件上传
const uploadRef = ref<UploadInstance[]>([])

const isLoading = ref(false)
const filesListLength = ref(0)

// 文件上传时所需要的签名
const uploadSign = useSign()

//改变的时候触发
const handleChange: UploadProps['onChange'] = (uploadFile, uploadFiles) => {
  filesListLength.value = uploadFiles.length
  if (filesListLength.value > 0) {
    fileUpDisabled.value = true
    mediaFile.value = uploadFile
  } else {
    fileUpDisabled.value = false
  }
  console.log('filesListLength.value', filesListLength.value)
}

const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
  filesListLength.value = uploadFiles.length
  if (filesListLength.value > 0) {
    fileUpDisabled.value = true
    mediaFile.value = uploadFile
  } else {
    fileUpDisabled.value = false
  }
  console.log('filesListLength.value', filesListLength.value)
}

//验证输入的信息（信息不能为空）
const checkInput = (rule: any, value: any, callback: any) => {
  if (!value) {
    return callback(new Error('请输入相关内容'))
  }
}

const checkVideo = (rule: any, value: any, callback: any) => {
  if (projectInfo.value.workVideo === '') {
    return callback(new Error('请上传作品视频'))
  }
}

const ruleProjectInfo = ref<FormInstance>()
const rules = reactive<FormRules<typeof projectInfo>>({
  workName: [
    { required: true, message: '请输入作品名称', trigger: 'blue' },
    { min: 2, message: '名称至少两个字符', trigger: 'blur' },
  ],
  workAuthor: [
    { required: true, message: '请输入作者信息', trigger: 'blue' },
    { validator: checkInput, trigger: 'blur' },
  ],
  workIntroduce: [
    { required: true, message: '请输入作品介绍', trigger: 'blue' },
    { validator: checkInput, trigger: 'blur' },
  ],
  workVideo: [
    { required: true, message: '请上传作品视频', trigger: 'blue' },
    { validator: checkVideo, trigger: 'blur' },
  ],
})

//限制上传的格式和上传的大小
const beforeAvatarUpload = () => {
  const rawFile = mediaFile.value
  if (rawFile.raw.type !== 'video/mp4') {
    ElMessage.error('请上传 mp4 格式的文件')
    return false
  } else if (rawFile.size / 1024 / 1024 > 200) {
    ElMessage.error('文件大小不能超过 200MB!')
    return false
  }
  return true
}

// 获取签名
async function getSignature() {
  if (uploadSign.Sign == '' || uploadSign.Sign == undefined) {
    const data = await getUploadSign(loginInfo.platform)
    if (data.data.sign) {
      // 设置 cookie 时间为 1 hour
      const signCookie = useCookie(signKey, {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      })
      signCookie.value = data.data.sign
      uploadSign.initUploadSign(data.data.sign)
    }
  }
  const sign = uploadSign.Sign
  console.log('获取到的 sign = ', sign)
  return sign
}

// 文件上传中显示
const uploadingResponser = async (res: any) => {
  isLoading.value = true
}

//视频上传成功时的回调
const successResponser = async (res) => {
  if (res !== undefined || res !== null) {
    projectInfo.value.workVideo = res
    const obj = {
      url: RequestAPI.PROJECT_UPLOAD,
      body: {
        workName: projectInfo.value.workName,
        workAuthor: projectInfo.value.workAuthor,
        workType: projectInfo.value.workType,
        workIntroduce: projectInfo.value.workIntroduce,
        workNote: projectInfo.value.workNote,
        workVideo: projectInfo.value.workVideo,
      },
    }

    const { data } = await postRequired(obj)
    console.log('上传作品的信息 === ', data.value)
    if (data.value) {
      isLoading.value = false
      if (data.value.code === 2000) {
        ElMessage({
          message: '作品上传成功',
          type: 'success',
        })
        projectInfo.value.workName = ''
        projectInfo.value.workAuthor = ''
        projectInfo.value.workType = 3
        projectInfo.value.workIntroduce = ''
        projectInfo.value.workNote = ''
        projectInfo.value.workVideo = ''

        uploadRef.value = []
        emit('update:showFileUpload', false)
      } else {
        ElMessage({
          message: data.value.msg,
          type: 'error',
        })
        uploadRef.value = []
        emit('update:showFileUpload', false)
      }
    } else {
      ElMessage({
        message: '视频上传失败,请重试',
        type: 'error',
      })
      emit('update:showFileUpload', false)
    }
  } else {
    ElMessage({
      message: '视频上传失败,请重试',
      type: 'error',
    })
    emit('update:showFileUpload', false)
  }
}

//作品上传先视频上传，之后再是信息上传
// async function videoUpload() {
//     uploadRef.value!.submit()
// }

// //信息上传
// async function workUpload() {
//     videoUpload();
// }
</script>
